// === Task 37 — transient (non-undoable) workflowSuggestions slice ===
// Holds the active WorkflowSuggestionList row loaded from the middleware.
// Sits OUTSIDE undoGroup (mirrors flowViewerOpen/workflowOverlayOpen) so the
// suggestions panel never pollutes user-edit undo/redo history.
//
// Shape:
//   loading     boolean  — true between REQUEST and SUCCESS/FAILURE
//   error       string|null — last failure message (cleared on next REQUEST)
//   suggestions array|null — flattened items[] from the persisted payload
//   scope       'course'|'scene'|null — copied from payload.suggestions.scope
//   generatedAt string|Date|null — server createdAt of the persisted row
import {
  LOAD_SUGGESTIONS_REQUEST,
  LOAD_SUGGESTIONS_SUCCESS,
  LOAD_SUGGESTIONS_FAILURE,
} from "../common/actions";

export const initialState = {
  loading: false,
  error: null,
  suggestions: null,
  scope: null,
  generatedAt: null,
};

export default function workflowSuggestions(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUGGESTIONS_REQUEST:
      return { ...state, loading: true, error: null };
    case LOAD_SUGGESTIONS_SUCCESS: {
      const payload = action.payload || {};
      // The middleware wraps the persisted WorkflowSuggestionList in a
      // `suggestions` field. Items + scope live one level deeper. Stay
      // defensive against null/empty rows (no active suggestions yet).
      const inner =
        payload.suggestions && typeof payload.suggestions === "object" ? payload.suggestions : null;
      return {
        ...state,
        loading: false,
        suggestions: (inner && Array.isArray(inner.items) && inner.items) || null,
        scope: (inner && inner.scope) || null,
        generatedAt: payload.generatedAt || null,
      };
    }
    case LOAD_SUGGESTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: (action.payload && action.payload.error) || "unknown",
      };
    default:
      return state;
  }
}
